export default "__VITE_ASSET__CsFrCwLSzvD5LTOe6d9BNg__"